/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


export {ÉµEmptyOutletComponent} from './components/empty_outlet';
export {ROUTER_PROVIDERS as ÉµROUTER_PROVIDERS} from './router_module';
export {flatten as Éµflatten} from './utils/collection';
